export default "__VITE_ASSET__ff87543f__"